<template>
  <select
    v-bind:name="groupName"
    ref="select"
  >
    <!-- <option v-for="option in options" :value="option.id" :key="option.name" >{{option.text}}</option> -->
  </select>
</template>
<script>
import { SET_FILTERS_SELECTION } from "@/vuex/mutation-types";

export default {
  props: ["childs", "moduleName", "groupName", "placeholder", "selectOptions"],
  data: function () {
    return {};
  },
  mounted: function () {
    this.$select
      // init select2
      .select2(this.initData)
      .val(null)
      .val(this.selectValue || "")
      .trigger("change")
      // emit event on change.
      .on("select2:select select2:unselect", this.updateSelection);
  },
  destroyed: function () {
    if (this.$select) this.$select.off().select2("destroy");
  },
  watch: {
    selectValue: function () {
      // update value
      this.$select.val(null).val(this.selectValue).trigger("change");
    },
    options: function () {
      // update options
      this.$select
        .empty()
        .select2(this.initData)
        .val(null)
        .val(this.selectValue || "")
        .trigger("change");
    },
  },
  computed: {
    initData() {
      return Object.assign(
        { data: this.options, width: "100%", placeholder: this.placeholder },
        this.selectOptions
      );
    },
    $select: function () {
      // eslint-disable-next-line no-undef
      return $(this.$refs.select);
    },
    options: function () {
      return this.childs.map((o) => {
        return { id: o.name, text: o.text };
      });
    },
    selectValue: function () {
      var value = this.childs
        .filter((c) => {
          var some = c.id.some((id) => {
            return this.selectionArr.indexOf(id) > -1;
          });
          return some;
        })
        .map((c) => {
          //map names
          return c.name;
        });
      return value;
    },
    selectionArr() {
      return (
        this.$store.state[this.moduleName].filters.filtersSelection[
          this.groupName
        ] || []
      );
    },
  },
  methods: {
    filterValue: function () {
      var selected = this.$select.select2("data").map((opt) => {
        return opt.id;
      });

      var selection = [],
        child;
      for (var i = 0; i < selected.length; i++) {
        child = this.childs.find((c) => {
          return c.name == selected[i];
        });
        if (child) selection = selection.concat(child.id);
      }
      return selection;
    },
    updateSelection() {
      this.$store.commit(
        this.moduleName + "/filters/" + SET_FILTERS_SELECTION,
        { name: this.groupName, value: this.filterValue() }
      );
    },
  },
};
</script>
